/**
 * GraphQL Query
 * 出荷
 */

/**
 * GraphQLで配送休業日情報を取得する
 */
export const GRAPH_QL_QUERY_SHIPPING_METHODS_LIST =
`
  query {
    shippingMethods ( ? ) {
      shippingMethod
    }
  }
`
/**
 * GraphQLで配送休業日一覧情報を取得する
 */
export const GRAPH_QL_QUERY_SHIP_HOLIDAY_LIST =
`
  query {
    shipHolidays ( ? ) {
      edges {
        node {
          id
          siteRefid
          shippingMethodCode
          holidayAt
          note
          isActive
        }
      }
      totalCount
    }
  }
`
